// extracted by mini-css-extract-plugin
export default {"setting--inverted":"Zq6LXpZ","dark-theme":"swoMeEY","timeslotSelection":"QTackgz","timebubble":"xeTocuu","timebubble--selected":"xZ4BzhG"};